import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bb5f257"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "symbol-panel" }
const _hoisted_2 = { class: "pool" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "symbol" }

import { computed, ref } from 'vue'
import { SYMBOL_LIST } from '@/configs/symbol'
import emitter, { EmitterEvents } from '@/utils/emitter'
import Tabs from '@/components/Tabs.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SymbolPanel',
  setup(__props) {

const selectedSymbolKey = ref(SYMBOL_LIST[0].key)
const symbolPool = computed(() => {
  const selectedSymbol = SYMBOL_LIST.find(item => item.key === selectedSymbolKey.value)
  return selectedSymbol?.children || []
})

const tabs = SYMBOL_LIST.map(item => ({
  key: item.key,
  label: item.label,
}))

const selectSymbol = (value: string) => {
  emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action: { command: 'insert', value } })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Tabs, {
      tabs: _unref(tabs),
      value: selectedSymbolKey.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedSymbolKey).value = $event)),
      tabsStyle: { marginBottom: '8px' },
      spaceBetween: ""
    }, null, 8, ["tabs", "value"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(symbolPool.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "symbol-item",
          key: index,
          onClick: ($event: any) => (selectSymbol(item))
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(item), 1)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})